import React from "react";
import {Box, Button, Column, Columns, Modal, Section, Title} from "@allxsmith/bestax-bulma";



export default function PrintOptionsModal({conf=[], open, setOpen}){

    return (
        <Modal active={open} onClose={() => setOpen(false)}>
            <Modal.Content>
                <Section style={{ backgroundColor: "grey" }}>
                    <Box>
                        <Columns>
                            <Title>Which printout do you need?</Title>
                        </Columns>
                        <Columns>
                            {conf.map(button => (
                                <Column>
                                    <Button
                                        color={button.color ?? "warning"}
                                        isFullWidth
                                        onClick={button.onClick}
                                    >
                                        {button.label}
                                    </Button>
                                </Column>
                            ))}
                            <Button
                                color={"info"}
                                isFullWidth
                                onClick={() => setOpen(false)}
                            >
                                Cancel
                            </Button>
                        </Columns>
                    </Box>
                </Section>
            </Modal.Content>
        </Modal>
    )


}